// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Device } from '@capacitor/device';
import config from 'config';
/* eslint-disable */
declare let _cio: any[];

if (!config.customerioApiKey) {
  var a, b, c;
  a = function (f) {
    return function () {
      _cio.push([f].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  b = ['load', 'identify', 'sidentify', 'track', 'page'];
  for (c = 0; c < b.length; c++) {
    // @ts-ignore
    _cio[b[c]] = a(b[c]);
  }

  var t = document.createElement('script'),
    s = document.getElementsByTagName('script')[0];
  t.async = true;
  t.id = 'cio-tracker';
  t.setAttribute('data-site-id', config.customerioSiteId);
  t.src = 'https://assets.customer.io/assets/track-eu.js';

  s.parentNode.insertBefore(t, s);
} else {
  const url = 'https://track-eu.customer.io/api/v1/';
  const authData = btoa(
    `${config.customerioSiteId}:${config.customerioApiKey}`,
  );

  const requestConfig: RequestInit = {
    method: 'POST',
    headers: {
      Authorization: 'Basic ' + authData,
      'Content-Type': 'application/json',
    },
  };
  let userId;

  const cioFetch = async (url: string, body, additionalConfig = {}) => {
    try {
      const response = await fetch(url, {
        ...requestConfig,
        ...additionalConfig,
        body: JSON.stringify(body),
      });
      if (response.status !== 200) {
        throw new Error(response.statusText);
      }
    } catch (error) {
      console.error(error);
    }
  };

  _cio = {
    page: async (path: any) => {
      let endpoint, body;

      if (userId) {
        endpoint = `customers/${userId}/events`;
        body = {
          type: 'page',
          name: path,
        };
      } else {
        const anonymous_id = await Device.getId().then((result) => {
          return result.uuid;
        });
        endpoint = 'events';
        body = {
          type: 'page',
          name: path,
          anonymous_id: anonymous_id,
        };
      }

      await cioFetch(url + endpoint, body);
    },
    track: async (eventName: string, data: any) => {
      let endpoint, body;

      if (userId) {
        endpoint = `customers/${userId}/events`;
        body = {
          name: eventName,
          data: data,
        };
      } else {
        const anonymous_id = await Device.getId().then((result) => {
          return result.uuid;
        });
        endpoint = 'events';
        body = {
          name: eventName,
          data: data,
          anonymous_id: anonymous_id,
        };
      }
      await cioFetch(url + endpoint, body);
    },
    identify: async (identifier) => {
      userId = identifier.id;
      const endpoint = `customers/${userId}`;

      const anonymous_id = await Device.getId().then((result) => {
        return result.uuid;
      });
      await cioFetch(
        url + endpoint,
        { anonymous_id: anonymous_id },
        { method: 'PUT' },
      );
    },
    newsletter: async (identifier) => {
      userId = identifier.email;
      const endpoint = `customers/${userId}`;

      const anonymous_id = await Device.getId().then((result) => {
        return result.uuid;
      });

      await cioFetch(
        url + endpoint,
        {
          anonymous_id: anonymous_id,
          mailing_agreement: identifier.mailing_agreement,
          name: identifier.name,
        },
        { method: 'PUT' },
      );
    },
  };
}

/* Google Tag Manager */
(function (w, d, s, l, i) {
  // @ts-ignore
  w[l] = w[l] || [];
  // @ts-ignore
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-T5G8D3H');
export default _cio;
